document.addEventListener('alpine:init', () => {
  const syncRechargeCartWithTheme = () => {
    const rechargeCartDrawer = document.getElementById('recharge-storefront-experiences__cart-drawer');

    if (!rechargeCartDrawer) {
      return;
    }

    const extractCartCount = (shadowRoot) => {
      if (!shadowRoot) return null;

      const cartTitleElement = shadowRoot.querySelector('.dynamic-richtext h2');
      if (!cartTitleElement) return null;

      const titleText = cartTitleElement.textContent || '';
      const match = titleText.match(/\((\d+)\)/);

      return match ? parseInt(match[1], 10) : null;
    };

    const updateCartCounters = (count) => {
      if (count === null) return;

      const counterIds = [
        'cart-icon-bubble',
        'mobile-cart-icon-bubble',
        'cart-icon-bubble-mobile-dock'
      ];

      counterIds.forEach(id => {
        const counterElement = document.getElementById(id);
        if (!counterElement) return;

        const counterSpan = counterElement.querySelector('span[aria-hidden="true"]');
        const counterDiv = counterElement.querySelector('div');

        if (counterSpan && counterDiv) {
          if (count < 100) {
            counterSpan.textContent = count;
          } else {
            counterSpan.textContent = '99+';
          }

          if (count === 0) {
            counterDiv.classList.add('hidden');
          } else {
            counterDiv.classList.remove('hidden');
          }
        }
      });

      if (typeof Alpine !== 'undefined' && Alpine.store('xCartHelper')) {
        Alpine.store('xCartHelper').currentItemCount = count;
      }
    };

    const checkRechargeCartState = () => {
      if (!rechargeCartDrawer.shadowRoot) {
        return;
      }

      const cartDialog = rechargeCartDrawer.shadowRoot.querySelector('[role="dialog"]');
      const overlay = rechargeCartDrawer.shadowRoot.querySelector('[data-state]');

      if (!cartDialog && !overlay) {
        return;
      }

      const isOpen = overlay?.getAttribute('data-state') === 'open' ||
                     cartDialog?.getAttribute('data-state') === 'open';

      if (Alpine.store('xMiniCart')) {
        if (!isOpen && Alpine.store('xMiniCart').open) {
          Alpine.store('xMiniCart').hideCart();
        } else if (isOpen && !Alpine.store('xMiniCart').open) {
          Alpine.store('xMiniCart').open = true;
          Alpine.store('xPopup').open = true;
        }
      }
    };

    const syncCartCount = () => {
      const count = extractCartCount(rechargeCartDrawer.shadowRoot);
      if (count !== null) {
        updateCartCounters(count);
      }
    };

    const observeShadowRoot = () => {
      if (!rechargeCartDrawer.shadowRoot) {
        setTimeout(observeShadowRoot, 100);
        return;
      }

      const stateObserver = new MutationObserver((mutations) => {
        checkRechargeCartState();
      });

      stateObserver.observe(rechargeCartDrawer.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-state', 'aria-hidden']
      });

      const countObserver = new MutationObserver((mutations) => {
        syncCartCount();
      });

      countObserver.observe(rechargeCartDrawer.shadowRoot, {
        childList: true,
        subtree: true,
        characterData: true,
        characterDataOldValue: false
      });

      checkRechargeCartState();
      syncCartCount();
    };

    observeShadowRoot();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncRechargeCartWithTheme);
  } else {
    setTimeout(syncRechargeCartWithTheme, 500);
  }
});
